import { Component } from "react";
import styled, { css } from "styled-components";
import * as PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import ArrowButton from "basicComponents/ArrowButton/ArrowButton";
import { styling } from "styling";

export default class Step extends Component {
  static propTypes = {
    onNext: PropTypes.func,
    onBack: PropTypes.func,
    children: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    leftDisabled: PropTypes.bool,
    rightDisabled: PropTypes.bool,
    leftTransparent: PropTypes.bool,
    rightTransparent: PropTypes.bool,
    fullWidth: PropTypes.bool,
    contentWidth: PropTypes.string,
  };

  state = {
    width: window.innerWidth,
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({
      width: window.innerWidth,
    });
  };

  static defaultProps = {
    contentWidth: null,
  };

  get isLeftEnabled() {
    return !(this.props.disabled || this.props.leftDisabled);
  }

  get isRightEnabled() {
    return !(this.props.disabled || this.props.rightDisabled);
  }

  get isLeftClickable() {
    return (
      this.isLeftEnabled && !this.props.leftTransparent && this.props.onBack
    );
  }

  get isRightClickable() {
    return (
      this.isRightEnabled && !this.props.rightTransparent && this.props.onNext
    );
  }

  handleBack = e => {
    if (this.isLeftClickable) {
      this.props.onBack();
    }
    e.stopPropagation();
  };

  handleNext = e => {
    if (this.isRightClickable) {
      this.props.onNext();
    }
    e.stopPropagation();
  };

  renderLeftStepButton() {
    return (
      <ButtonContainer>
        <StepButton
          id="backButton"
          back
          clickable={this.isLeftClickable}
          transparent={this.props.leftTransparent}
          enabled={this.isLeftEnabled}
          onClick={this.handleBack}
        >
          <FormattedMessage {...GlobalMessages.previous} />
        </StepButton>
      </ButtonContainer>
    );
  }

  renderRightStepButton() {
    return (
      <ButtonContainer>
        <StepButton
          id="nextButton"
          clickable={this.isRightClickable}
          transparent={this.props.rightTransparent}
          enabled={this.isRightEnabled}
          onClick={this.handleNext}
        >
          <FormattedMessage {...GlobalMessages.next} />
          <span className="nextbtn"></span>
        </StepButton>
      </ButtonContainer>
    );
  }

  renderContent() {
    return (
      <ContentWrapper
        customWidth={this.props.contentWidth}
        fullWidth={this.props.fullWidth}
      >
        {this.props.children}
      </ContentWrapper>
    );
  }

  renderMobile() {
    return (
      <Wrapper column>
        {this.renderContent()}
        <ButtonRow>
          {this.props.noLeft ? <></> : this.renderLeftStepButton()}
          {this.renderRightStepButton()}
        </ButtonRow>
      </Wrapper>
    );
  }

  render() {
    if (this.state.width < styling.breakpointNumbers.desktopLargeUp) {
      return this.renderMobile();
    }

    return (
      <Wrapper center>
        {this.props.noLeft ? <></> : this.renderLeftStepButton()}
        {this.renderContent()}
        {this.renderRightStepButton()}
      </Wrapper>
    );
  }
}

function StepButton(props) {
  if (props.back) {
    return (
      <StepButtonDiv
        clickable={props.clickable}
        transparent={props.transparent}
        onClick={props.onClick}
      >
        {props.enabled && (
          <ArrowWrapper {...props}>
            <ArrowButton disabled={props.transparent} />
          </ArrowWrapper>
        )}
        {props.enabled && props.children}
      </StepButtonDiv>
    );
  }
  return (
    <StepButtonDiv
      clickable={props.clickable}
      transparent={props.transparent}
      onClick={props.onClick}
    >
      {props.enabled && props.children}
      {props.enabled && (
        <ArrowWrapper {...props}>
          <ArrowButton disabled={props.transparent} />
        </ArrowWrapper>
      )}
    </StepButtonDiv>
  );
}

function cursorType({ clickable }) {
  if (clickable) {
    return css`
      cursor: pointer;
    `;
  }
  return null;
}
const StepButtonDiv = styled.div`
  height: 30px;
  border-radius: 15px;
  ${cursorType};
  display: flex;
  min-width: 50px;
  background: ${({ transparent, theme }) =>
    transparent == undefined ? "#f6efe8" : "white"};
  color: ${({ transparent, theme }) =>
    transparent ? theme.disabledColor : "black"};
  border: ${({ transparent }) =>
    transparent === false ? "1px solid black" : "0px solid black"};
  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
    cursor: pointer;
    transition: color 0.2s;
  }
  span {
    user-select: none;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ArrowWrapper = styled.div`
  width: 24px;
  ${({ back }) => (back ? "transform: scale(-1, 1)" : "")};
  padding-bottom: ${({ theme }) => theme.padding}rem;
`;

const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: ${({ theme }) => theme.padding}rem;
  padding-right: ${({ theme }) => theme.padding}rem;
`;

const Wrapper = styled.div`
  width: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: ${({ column }) => (column ? "column" : "row")};
  align-items: stretch;
  justify-content: ${({ center }) => (center ? "center" : "flex-start")};
`;

function contentWrapperWidth({ fullWidth, customWidth }) {
  if (customWidth !== null && customWidth !== undefined) {
    return `width: ${customWidth};`;
  }
  if (fullWidth) {
    return "width: 100%;";
  }
  return "";
}
const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  ${contentWrapperWidth};
`;
